import * as _m from '@/models';
import { Link } from 'react-router-dom';
import { SpriteSvg } from '@/components/common/SpriteSvg';

export const SnsIcons = ({ channel }: { channel: _m.Channel }) => {
  const youtubeRel = channel.related_urls.find((relUrl) => relUrl.sns_type.name == 'youtube');
  const xRel = channel.related_urls.find((relUrl) => relUrl.sns_type.name == 'x');

  if (!youtubeRel && !xRel) {
    return <></>;
  }

  return (
    <div className="sns-wrapper">
      {youtubeRel && (
        <Link to={youtubeRel.content} target="_blank">
          <SpriteSvg name={'icon-yt'} className={'i'} />
        </Link>
      )}
      {xRel && (
        <Link to={xRel.content} target="_blank">
          <SpriteSvg name={'icon-x'} className={'i'} />
        </Link>
      )}
    </div>
  );
};
